<template>
  <base-list-table :data="data" :structure="structure" :refreshFunction="refreshPage" />
  <!-- Shipping modal -->
  <Teleport to="body">
    <base-confirm-field :show="showShipModal" @close="showShipModal = false">
      <template #header>
        <h3>Spedizione RFID</h3>
      </template>
      <template #body>
        <p>Inserisci nome, cognome e indirizzo utilizzati nella spedizione per andare avanti</p>
        <base-input-field title="Nome e indirizzo" v-model="shipping_address" />
      </template>
      <template #footer>
        <div class="flex justify-between">
          <p>Confermare?</p>
          <div>
            <button v-show="shipping_address !== ''" class="w-6 h-6 hover:bg-primary-200 text-sm rounded-full mr-2" type="button" @click="shipCard">Si</button>
            <button class="w-6 h-6 hover:bg-red-200 text-sm rounded-full" type="button" @click="resetField">No</button>
          </div>
        </div>
      </template>
    </base-confirm-field>
  </Teleport>
  <!-- Unshipping modal -->
  <Teleport to="body">
    <base-confirm-field :show="showUnshipModal" @close="showUnshipModal = false">
      <template #header>
        <h3>Annullamento spedizione</h3>
      </template>
      <template #body>
        <p>Andando avanti annullerai la spedizione e cancellerai l'indirizzo</p>
      </template>
      <template #footer>
        <div class="flex justify-between">
          <p>Confermare?</p>
          <div>
            <button class="w-6 h-6 hover:bg-primary-200 text-sm rounded-full mr-2" type="button" @click="unshipCard">Si</button>
            <button class="w-6 h-6 hover:bg-red-200 text-sm rounded-full" type="button" @click="resetField">No</button>
          </div>
        </div>
      </template>
    </base-confirm-field>
  </Teleport>
  <!-- Reassign modal -->
  <Teleport to="body">
    <base-confirm-field :show="showManageModal" width="580px" @close="closeManageModal">
      <template #header>
        <div class="flex items-center gap-2">
          <span>Gestione carta RFID</span>
          <span v-if="manage_card" class="text-primary-500 font-mono text-lg">{{ manage_card.codice }}</span>
        </div>
      </template>
      <template #body>
        <div class="flex flex-col gap-4">
          <!-- stato attuale -->
          <div
            class="flex items-center gap-3 px-4 py-3 rounded-xl border"
            :class="manage_card && manage_card.user_name
              ? 'bg-primary-50 border-primary-200 dark:bg-primary-900/20 dark:border-primary-700'
              : 'bg-gray-50 border-gray-200 dark:bg-gray-800 dark:border-gray-700'"
          >
            <span
              class="material-icons text-2xl"
              :class="manage_card && manage_card.user_name ? 'text-primary-500' : 'text-gray-400'"
            >
              {{ manage_card && manage_card.user_name ? 'person' : 'person_off' }}
            </span>
            <div v-if="manage_card && manage_card.user_name">
              <p class="text-sm font-semibold text-gray-800 dark:text-white leading-tight">{{ manage_card.user_name }}</p>
              <p class="text-xs text-primary-500 leading-tight">Proprietario attuale</p>
            </div>
            <div v-else>
              <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Carta non assegnata</p>
            </div>
          </div>

          <!-- ricerca + lista utenti -->
          <div>
            <p class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Assegna ad un utente:</p>
            <input
              v-model="userSearch"
              type="text"
              placeholder="Cerca per nome o email..."
              class="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 text-sm mb-2 focus:outline-none focus:ring-2 focus:ring-primary-400 dark:bg-gray-900 dark:text-white"
              @input="selected_user_uid = null"
            />
            <div class="overflow-y-auto rounded-xl border border-gray-200 dark:border-gray-700" style="max-height: 240px;">
              <div
                v-for="u in filteredUsersList"
                :key="u.uid"
                class="flex items-center gap-3 px-4 py-3 cursor-pointer border-b border-gray-100 dark:border-gray-800 last:border-b-0 transition-colors"
                :class="selected_user_uid === u.uid
                  ? 'bg-primary-50 dark:bg-primary-900/30'
                  : 'hover:bg-gray-50 dark:hover:bg-gray-800'"
                @click="selected_user_uid = u.uid"
              >
                <span
                  class="material-icons text-xl"
                  :class="selected_user_uid === u.uid ? 'text-primary-500' : 'text-gray-400'"
                >
                  {{ selected_user_uid === u.uid ? 'radio_button_checked' : 'radio_button_unchecked' }}
                </span>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-semibold text-gray-800 dark:text-white leading-tight truncate">
                    {{ u.name }} {{ u.surname }}
                  </p>
                  <p v-if="u.email" class="text-xs text-gray-500 dark:text-gray-400 leading-tight truncate">{{ u.email }}</p>
                  <p v-else-if="u.cellphone" class="text-xs text-gray-500 dark:text-gray-400 leading-tight">{{ u.cellphone }}</p>
                </div>
              </div>
              <div v-if="filteredUsersList.length === 0" class="px-4 py-6 text-center text-sm text-gray-400">
                Nessun risultato
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="flex justify-between items-center gap-3 pt-2">
          <button
            v-if="manage_card && manage_card.user_name"
            class="flex items-center gap-1 px-4 py-2 text-sm rounded-lg bg-red-50 hover:bg-red-100 text-red-600 font-semibold transition-colors"
            type="button"
            @click="freeCard"
          >
            <span class="material-icons text-base">link_off</span>
            Libera carta
          </button>
          <span v-else></span>
          <div class="flex gap-2">
            <button
              :disabled="!selected_user_uid"
              class="flex items-center gap-1 px-4 py-2 text-sm rounded-lg font-semibold transition-colors"
              :class="selected_user_uid
                ? 'bg-primary-500 hover:bg-primary-600 text-white'
                : 'bg-gray-100 dark:bg-gray-800 text-gray-400 cursor-not-allowed'"
              type="button"
              @click="reassignCard"
            >
              <span class="material-icons text-base">person_add</span>
              Assegna
            </button>
            <button
              class="px-4 py-2 text-sm rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-300 transition-colors"
              type="button"
              @click="closeManageModal"
            >
              Annulla
            </button>
          </div>
        </div>
      </template>
    </base-confirm-field>
  </Teleport>
</template>

<script>
  import { useStore } from 'vuex';
  import { computed, ref } from 'vue';
  export default {
    setup() {
      const store = useStore();
      function refreshPage(payload) {
        store.dispatch('getCompleteRfidList', payload);
      }
      const completeRfidList = computed(() => store.getters.completeRfidList);
      const completeUsersList = computed(() => store.getters.completeUsersList);

      const structure = {
        title: 'views.rfid.title',

        creationLink: {
          title: 'buttons.createRfid',
          namePath: 'menu.user.rfidCreation',
        },
        data: [
          {
            title: 'rfid.code',

            field: 'codice',
            span: 1,
          },
          {
            title: 'rfid.tag',
            field: 'id_tag',
            span: 1,
          },
          {
            title: 'views.rfid.cardOwner',
            fields: [
              {
                placeholder: '@',
                name: 'user_id',
                class: 'text-primary-400',
              },
              {
                name: 'user_name',
              },
            ],
            span: 1,
            link: { idField: 'user_id', path: '/user/users/:id' },
          },
          {
            title: 'status',

            field: 'shipped',
            boolean: {
              if_true: 'rfid.shipped',
              if_false: 'rfid.toShip',
            },
            span: 1,
          },
          {
            title: 'views.rfid.bonus',

            field: 'euro_bonus',
            format: 'euro',
            span: 1,
          },
          {
            title: 'shippingAddress',

            field: 'shipping_address',
            span: 1,
          },
          {
            title: 'views.rfid.actions',

            buttons: {
              fields: [
                {
                  title: 'buttons.ship',

                  function: showShippingModal,
                  returned_val: 'rfid_id',
                  condition_val: 0,
                },
                {
                  title: 'buttons.cancel',

                  function: showUnshippingModal,
                  returned_val: 'rfid_id',
                  condition_val: 1,
                },
              ],
              condition: 'shipped',
            },
            span: 1,
          },
          {
            title: 'Assegnazione',
            buttons: {
              fields: [
                {
                  title: 'Gestisci',
                  function: showManageModalFn,
                },
              ],
            },
            span: 1,
          },
        ],
      };
      const showShipModal = ref(false);
      const showUnshipModal = ref(false);
      const showManageModal = ref(false);
      const shipping_address = ref('');
      const selected_rfid = ref(null);

      // manage modal state
      const manage_card = ref(null);
      const userSearch = ref('');
      const selected_user_uid = ref(null);

      const filteredUsersList = computed(() => {
        const list = completeUsersList.value || [];
        const arr = Array.isArray(list) ? list : (list.data || []);
        const q = userSearch.value.trim().toLowerCase();
        if (!q) return arr;
        return arr.filter((u) =>
          `${u.name} ${u.surname}`.toLowerCase().includes(q) ||
          (u.email && u.email.toLowerCase().includes(q))
        );
      });

      //showModal functions
      function showShippingModal(el) {
        showShipModal.value = true;
        selected_rfid.value = el;
      }
      function showUnshippingModal(el) {
        showUnshipModal.value = true;
        selected_rfid.value = el;
      }
      function showManageModalFn(el) {
        manage_card.value = el;
        userSearch.value = '';
        selected_user_uid.value = null;
        store.dispatch('getCompleteUsersList');
        showManageModal.value = true;
      }
      function closeManageModal() {
        showManageModal.value = false;
        manage_card.value = null;
        userSearch.value = '';
        selected_user_uid.value = null;
      }

      //method for send update query
      function shipCard() {
        const payload = {
          id: selected_rfid.value,
          address: shipping_address.value,
          shipped: 1,
        };
        store.dispatch('updateRfid', payload);
        resetField();
      }
      function unshipCard() {
        const payload = {
          id: selected_rfid.value,
          address: ' ',
          shipped: '0',
        };
        store.dispatch('updateRfid', payload);
        resetField();
      }
      async function reassignCard() {
        if (!manage_card.value || !selected_user_uid.value) return;
        await store.dispatch('reassignRfid', {
          rfid_id: manage_card.value.rfid_id,
          user_uid: selected_user_uid.value,
        });
        closeManageModal();
        store.dispatch('getCompleteRfidList');
      }
      async function freeCard() {
        if (!manage_card.value) return;
        await store.dispatch('freeRfid', { rfid_id: manage_card.value.rfid_id });
        closeManageModal();
        store.dispatch('getCompleteRfidList');
      }
      function resetField() {
        showShipModal.value = false;
        showUnshipModal.value = false;
        shipping_address.value = '';
        selected_rfid.value = null;
      }
      return {
        data: completeRfidList,
        structure,
        showShipModal,
        showUnshipModal,
        showManageModal,
        shipping_address,
        shipCard,
        unshipCard,
        resetField,
        refreshPage,
        manage_card,
        userSearch,
        selected_user_uid,
        filteredUsersList,
        reassignCard,
        freeCard,
        closeManageModal,
      };
    },
  };
</script>

<style></style>

